// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { DeadlinesRoutingModule } from './deadlines-routing.module';

// Custom packages - Components
import { ViewPlatformNotesDialogComponent } from 'src/app/components/platform-note-card/components/view-platform-notes-dialog/view-platform-notes-dialog.component';
import { NfcAccessSubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/nfc-access-subscriptions-deadlines-list/nfc-access-subscriptions-deadlines-list.page';
import { PrivacySagSubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/privacy-sag-subscriptions-deadlines-list/privacy-sag-subscriptions-deadlines-list.page';
import { PrivacySubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/privacy-subscriptions-deadlines-list/privacy-subscriptions-deadlines-list.page';
import { SubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/subscriptions-deadlines-list/subscriptions-deadlines-list.page';
import { SuppliersSubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/suppliers-subscriptions-deadlines-list/suppliers-subscriptions-deadlines-list.page';
import { BalanceListDialogComponent } from './components/balances-list-dialog/balances-list-dialog.component';
import { DocumentsDeadlinesListComponent } from './pages/documents-deadlines-list/documents-deadlines-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    DeadlinesRoutingModule,
    PublicModule,
  ],
  declarations: [
    SubscriptionsDeadlinesListComponent,
    DocumentsDeadlinesListComponent,
    BalanceListDialogComponent,
    SuppliersSubscriptionsDeadlinesListComponent,
    NfcAccessSubscriptionsDeadlinesListComponent,
    PrivacySubscriptionsDeadlinesListComponent,
    PrivacySagSubscriptionsDeadlinesListComponent,
  ],
  entryComponents: [
    ViewPlatformNotesDialogComponent,
  ],
  exports: [
    BalanceListDialogComponent
  ]
})
export class DeadlinesModule { }
